<script setup>
import katex from 'katex';
import VModal from '~/components/common/VModal.vue';
import VTextArea from '~/components/NewTextarea.vue';

const props = defineProps({
  math: {
    type: String,
    default: '',
  },
  onUpdate: {
    type: Function,
  },
});

const emit = defineEmits(['update:math']);

const isOpened = ref(false);
const model = ref({ formula: props.math });
const katexElement = ref(null);

const onSave = () => {
  renderFormula(model.value.formula);
  props.onUpdate(model.value.formula);

  isOpened.value = false;
};

const onCancel = () => {
  model.value.formula = props.math;
  isOpened.value = false;
};

const renderFormula = (formula) => {
  try {
    katex.render(formula, katexElement.value, {
      throwOnError: false,
      displayMode: true,
      output: 'mathml',
    });
  } catch (e) {
    console.error('Ошибка рендеринга формулы:', e);
    katexElement.value.textContent = formula || 'Введите формулу';
  }
};

onMounted(() => {
  renderFormula(props.math);

  if (!props.math) {
    isOpened.value = true;
  }
});
</script>

<template>
  <div class="math-tool">
    <p
      class="math-tool__value"
      ref="katexElement"
    />
    <v-button
      @click="isOpened = true"
      schema="icon"
      class="math-tool__toggle"
    >
      <NuxtImg
        loading="lazy"
        src="/images/icons/project/cog.svg"
        alt=""
        width="16"
        height="16"
      />
    </v-button>
  </div>
  <v-modal
    :open="isOpened"
    title="Редактирование формулы"
    closable
    @close="onCancel"
  >
    <v-text-area
      name="formula"
      v-model="model.formula"
      type="text"
      placeholder="Введите формулу в LaTeX формате"
      aria-label="formula"
      autocomplete="formula"
      rows="2"
      maxlength="200"
      class="math-tool__modal-textarea"
    />
    <div class="math-tool__modal-buttons">
      <v-button
        schema="primary"
        medium
        @click="onSave"
        >Сохранить</v-button
      >
      <v-button
        outline
        secondary
        medium
        @click="onCancel"
      >
        Отмена
      </v-button>
    </div>
  </v-modal>
</template>

<style lang="scss" scoped>
.math-tool {
  display: flex;
  align-items: center;
  gap: 8px;
}

.math-tool__toggle {
  position: relative;
  bottom: 1px;
}

.math-tool__modal-textarea {
  width: 100%;
}

.math-tool__modal-buttons {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 24px;
  width: 100%;

  & button {
    width: 100%;
  }
}
</style>
